const styles = () => ({
  dashboardChartLegends: {
    display: 'flex',
  },
});

export default styles;
